import { useMemo } from 'react'
import { t } from 'i18next'
import useSWR from 'swr'
import { UserAction } from 'types/building'

export function getOrgString(u: any): string {
  if (typeof u?.organizationName === 'string' && u.organizationName.trim()) {
    return u.organizationName
  }
  if (typeof u?.organization_name === 'string' && u.organization_name.trim()) {
    return u.organization_name
  }
  if (typeof u?.organization === 'string' && u.organization.trim()) {
    return u.organization
  }
  if (typeof u?.organization === 'object' && u?.organization !== null) {
    return u.organization.name || u.organization.companyName || ''
  }
  if (typeof u?.company_name === 'string') return u.company_name
  if (typeof u?.companyName === 'string') return u.companyName
  return '-'
}

export function getRoleString(u: any): string {
  if (!u) return '-'

  const raw = u?.raw || u

  let roleCode = ''
  if (typeof raw?.role === 'string') {
    roleCode = raw.role
  } else if (typeof raw?.role_name === 'string') {
    roleCode = raw.role_name
  } else if (typeof raw?.role === 'object' && raw?.role !== null) {
    roleCode = raw.role.name || ''
  }

  const upperRole = roleCode.toUpperCase()

  if (upperRole === 'SA') {
    return t('user.roles.systemAdmin', 'システム管理者')
  }
  if (upperRole === 'BA') {
    return t('user.roles.branchAdmin', '支店管理者')
  }

  const action = String(raw?.action || u?.action || '').toUpperCase()

  if (action === UserAction.VIEW) {
    return '閲覧者'
  }

  return '編集者'
}

export function useBuildingUsersAndGroups(buildingId?: string | number) {
  const bId = buildingId ? String(buildingId) : ''

  const {
    data: searchData,
    isLoading: isLoadingUsers,
    mutate: mutateUsers
  } = useSWR(
    bId
      ? {
          url: `/v1/buildings/${bId}/users`,
          params: {
            page_size: 1000
          }
        }
      : null,
    {
      dedupingInterval: 2000
    }
  )

  const {
    data: userGroupsRes,
    isLoading: isLoadingGroups,
    mutate: mutateGroups
  } = useSWR(
    bId
      ? {
          url: `/v1/buildings/${bId}/user-groups`
        }
      : null,
    {
      dedupingInterval: 2000
    }
  )

  const userList = useMemo(() => {
    if (Array.isArray(searchData?.data?.edges)) return searchData.data.edges
    if (Array.isArray(searchData?.edges)) return searchData.edges
    if (Array.isArray(searchData?.data?.users)) return searchData.data.users
    if (Array.isArray(searchData?.users)) return searchData.users
    if (Array.isArray(searchData?.data)) return searchData.data
    if (Array.isArray(searchData)) return searchData
    return []
  }, [searchData])

  const userGroups = useMemo(() => {
    if (!userGroupsRes) return []
    if (Array.isArray(userGroupsRes)) return userGroupsRes
    if (Array.isArray(userGroupsRes.data)) return userGroupsRes.data
    return []
  }, [userGroupsRes])

  return {
    userList,
    userGroups,
    isLoadingUsers,
    isLoadingGroups,
    refetchUsers: mutateUsers,
    refetchGroups: mutateGroups,
    getOrgString,
    getRoleString
  }
}

export default useBuildingUsersAndGroups
